import { TradingEntity, TradingEntityType } from 'api'

const assignTradingEntityTypes = [TradingEntityType.BLOCK, TradingEntityType.STANDARD]

const isStandardType = (tradingEntity: TradingEntity) =>
  tradingEntity.tradingEntityTypes.includes(TradingEntityType.STANDARD) && tradingEntity.tradingEntityTypes.length === 1

const isBlockType = (tradingEntity: TradingEntity) =>
  tradingEntity.tradingEntityTypes.includes(TradingEntityType.BLOCK) && tradingEntity.tradingEntityTypes.length === 1

const isAssignType = (tradingEntity: TradingEntity) =>
  assignTradingEntityTypes.every(tradingEntityType => tradingEntity.tradingEntityTypes.includes(tradingEntityType))

export const TradingEntityTypeUtils = {
  isStandardType,
  isBlockType,
  isAssignType
}
